<template>
  <div>
    <span class="text-grey-dark text-sm font-medium leading-normal cursor-pointer hover:underline mb-3 inline-block" @click="$emit('clear')">&lt; All Orders</span>
    <panel class="pt-6">
      <loader v-if="order === null" />
      <div v-else>
        <div class="flex flex-wrap uppercase">
          <div class="p-3 border-b-4 border-transparent cursor-pointer" :class="{'border-black text-black': tab === 'marketing-pack-order-history-report-tab'}" @click="tab = 'marketing-pack-order-history-report-tab'">
            {{ selectedOffice.network_id === 2 ? 'Marketing Pack' : 'Enhanced Marketing Pack' }} Status Report
          </div>

          <div class="p-3 border-b-4 border-transparent cursor-pointer" :class="{'border-black text-black': tab === 'marketing-pack-order-history-overview-tab'}" @click="tab = 'marketing-pack-order-history-overview-tab'">
            Overview
          </div>
        </div>
        <hr class="border-b border-grey-darker w-full mt-0 mb-6" />

        <component :is="tab" :order="order" />
      </div>
    </panel>
  </div>
</template>

<script>
import api from '@/http'
import MarketingPackOrderHistoryReportTab from './MarketingPackOrderHistoryReportTab'
import MarketingPackOrderHistoryOverviewTab from './MarketingPackOrderHistoryOverviewTab'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    MarketingPackOrderHistoryReportTab,
    MarketingPackOrderHistoryOverviewTab
  },
  props: ['orderId'],
  data () {
    return {
      tab: 'marketing-pack-order-history-report-tab',
      order: null
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  created () {
    this.getOrder()
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    getOrder () {
      api.get(`/marketing-packs/orders/${this.orderId}`).then((response) => {
        this.order = response.data.data

        if (response.data.ehouse_sync === false) {
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Error',
            info: 'Unable to sync appointments with ehouse. The information on this page may not be up-to-date.'
          })
        }
      })
    }
  }
}
</script>
